var _style, _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotAnalysis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 78 78",
    style: {
      enableBackground: "new 0 0 78 78"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#A8A8A8;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62",
    className: "st0",
    d: "M8,0h62c4.4,0,8,3.6,8,8v8l0,0H0V8C0,3.6,3.6,0,8,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62_1_",
    className: "st0",
    d: "M0,26h20v52H8c-4.4,0-8-3.6-8-8V26L0,26z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-23",
    x: 29,
    y: 26,
    className: "st0",
    width: 20,
    height: 52
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-24",
    className: "st0",
    d: "M58,26h20v44c0,4.4-3.6,8-8,8H58l0,0V26z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAnalysis);
export default __webpack_public_path__ + "static/media/notAnalysis.a4257f9622244bedd9a578d4d93508aa.svg";
export { ForwardRef as ReactComponent };